<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area cs-courseSchedule-content">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="courseName" label="课程名称" label-width="100px">
          <el-input placeholder="请输入课程名称" v-model="form.courseName" ></el-input>
        </el-form-item>
        <el-form-item class="cs-courseSchedule-desc" label="上课时间" label-width="100px">
          <label>请添加该课所有的上课时间，包括<span class="cs-import-message">Lab或者Tutorial</span>等</label>
        </el-form-item>
        <el-row v-for="(schedule,index) in form.schedules" :key="index">
          <course-schedule-time-picker :rowIndex="index" :isSameAsAbove="form.isSameAsAbove" :currentSchedulesAll="form.schedules" :scheduleForm="schedule" :timeLeft="form.timeLeft" :unavailbeTime="form.unavailbeTime" v-on:reduceTime="onReduceTime" v-on:deleteRow="onDeleteRow" v-on:editRow="onEditingRow" ref="courseScheduleTimePicker">
          </course-schedule-time-picker>
        </el-row>
        <el-row>
          <el-col style="width:20px">&nbsp;</el-col>
          <el-col class="timepicker-col">
            <el-button :disabled="this.$data.form.timeLeft<=courseSpan/2" type="text" @click="addRow()"><i class="el-icon el-icon-plus"></i>添加</el-button>
          </el-col>
          <el-col class="timepicker-col">
            <el-alert v-show="this.$data.form.timeLeft<=courseSpan/2" title="已达到课时上限" :closable="false" type="error"> </el-alert>
          </el-col>
        </el-row>
      </el-form>
      <div class="errorMessage-container">
        <el-row>
          <el-col :span="22">
            <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
          </el-col>
        </el-row>
      </div>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="12" class="footer-left">
          <span v-if="!isEdit"></span>
          <el-button v-if="!!courseData.id" type="danger" @click="deleteCourse()">删 除</el-button>
        </el-col>
        <el-col class="footer-right" :span="12">
          <el-button :disabled="this.$data.form.timeLeft == this.$data.maxTotalSpan" type="primary" @click="save()">{{buttonText}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .cs-courseSchedule-editor {
    .cs-courseSchedule-content {
      position: relative;
      .errorMessage-container {
        position: absolute;
        bottom: 5px;
        width: 100%;
      }

      .cs-import-message{
        font-weight: bold;
        color:red;
      }
    }
    .popup-footer {
      padding: 0 50px;
      margin-right: 0;
      .footer-left {
        span {
          display: inline-block;
          width: 1px;
        }
      }
      .footer-right {
        text-align: right;
      }
    }
  }
</style>

<script>
  import courseScheduleTimePicker from "../components/courseScheduleTimePicker";
  import {
    guid,
    getStore,
    formatTimeToInt60
  } from "../config/mUtils";
  import {
    srcDaysOfWeek,
    srcTimesOfDay
  } from "../service/api-base.service";
  import {
    saveStudentCourse,
    deleteStudentCourse
  } from "../service/course.service";
  import { getStudent } from "@/service/student.service"

  export default {
    data() {
      return {
        courseSpan: 60,
        daysOfWeek: srcDaysOfWeek(),
        timesOfDay: srcTimesOfDay(),
        formLabelWidth: "120px",
        errorMessage: "",
        showError: false,
        buttonText: "确认添加",
        isEdit: false,
        courseTotalTime:0,
        // maxTimeUTM: 2100,
        form: {
          editingRowId:'',
          isSameAsAbove: true,
          courseName: "",
          maxTime: 720,
          timeLeft: 720,
          unavailbeTime: [],
          schedules: [{
            id: guid(),
            dataId: "",
            day: "",
            startTime: "",
            endTime: "",
            universityCourseType:"",
          }],
          removeIdList: []
        },
        rules: {
          courseName: [{
            required: true,
            message: "请输入课程名称",
            trigger: "blur"
          }]
        }
      };
    },
    components: {
      courseScheduleTimePicker
    },
    created() {
      this.loadUniversityTotalCourseMinutes();
      this.loadScheduleData();
      this.loadUnavailbeTime();
    },
    // props: {
    //   courseData: Object
    // },
    props: ["courseDataAll", "courseData"/*, "isCheckMaxTime"*/],
    methods: {
      async loadUniversityTotalCourseMinutes() {
        let studentId = getStore("user_student_id");
        let result = await getStudent(studentId);
        if (!!result && result.success) {
          this.form.maxTime = this.form.timeLeft = result.data.TotalCourseMinutes;
        }
      },
      loadScheduleData() {
        this.errorMessage = "";
        this.showError = false;
        this.form.removeIdList = [];
        if (!!this.courseData && this.courseData.isEdit) {
          this.buttonText = "确认修改";
          this.isEdit = true;
        } else {
          this.isEdit = false;
          this.buttonText = "确认添加";
        }
        if (!!this.courseData && !!this.courseData.courseName) {
          this.$data.form.courseName = this.courseData.courseName;
        } else {
          this.$data.form.courseName = "";
        }
        if (!!this.courseData &&
          !!this.courseData.schedules &&
          this.courseData.schedules.length > 0
        ) {
          let list = [];
          let timeSubtotal = 0;
          this.courseData.schedules.forEach(element => {
            let dayofweek = element.DayOfWeek;
            if (dayofweek == 0) {
              dayofweek = 7;
            }
            let startTime = formatTimeToInt60(element.StartTimeText);
            let endTime = formatTimeToInt60(element.EndTimeText, true);
            let item = {
              id: guid(),
              dataId: element.Id,
              day: dayofweek,
              startTime: startTime,
              endTime: endTime,
              universityCourseType: element.UniversityCourseType
            };
            list.push(item);
            let timeSpan = this.getTimespan(item.startTime, item.endTime);
            timeSubtotal += timeSpan;
          });
          this.$data.form.schedules = list;
          this.$data.form.timeLeft = this.$data.form.maxTime - timeSubtotal;
        } else {
          this.$data.form.timeLeft = this.$data.form.maxTime;
          this.$data.form.schedules = [{
            id: guid(),
            dataId: "",
            day: "",
            startTime: "",
            endTime: "",
            universityCourseType:""
          }];
        }
        
      },
      loadUnavailbeTime() {
        let list = [];
        this.courseTotalTime = 0;
        if (!!this.courseDataAll) { 

          this.courseDataAll.forEach(course => {
            if (!!this.courseData && this.courseData.id !== course.Id) {              
              course.ScheduleList.forEach(element => {
                let dayofweek = element.DayOfWeek;
                if (dayofweek == 0) {
                  dayofweek = 7;
                }
                let startTime = formatTimeToInt60(element.StartTimeText);
                let endTime = formatTimeToInt60(element.EndTimeText, true);
                let timeSpan = this.getTimespan(startTime, endTime);
                this.courseTotalTime += timeSpan;
                let item = {
                  id: guid(),
                  dataId: element.Id,
                  day: dayofweek,
                  startTime: startTime,
                  endTime: endTime,
                  courseName: course.CourseName
                };
                list.push(item);
              });
            }
          });
        }
        this.form.unavailbeTime = list;
        this.form.schedules.forEach((e, i) => {
          let item = {
            id: e.id,
            dataId: 0,
            day: e.day,
            startTime: e.startTime,
            endTime: e.endTime,
            courseName:this.$data.form.courseName
          };
          this.$data.form.unavailbeTime.push(item);

          if (!!e.startTime && !!e.endTime){
            let timeSpan = e.endTime - e.startTime;
            this.courseTotalTime += timeSpan;
          }
          
        });
     
        // if (this.isCheckMaxTime && this.courseTotalTime > 0){

        //   let timeLeft = this.maxTimeUTM - this.courseTotalTime;
        //   if (timeLeft < 0){
        //     timeLeft = 0;
        //   }

        //   if (this.form.timeLeft > timeLeft){
        //      this.form.timeLeft = timeLeft;
        //   }
        // }
      },
      checkAllTimeIsSame() {
        this.$data.form.isSameAsAbove = true;
        if (this.$data.form.schedules) {
          this.$data.form.schedules.forEach((item, i) => {
            if (i > 0 && item.id !== this.$data.form.editingRowId && item.startTime !== '' && item.endTime !== '') {
              if (item.endTime !== this.$data.form.schedules[i - 1].endTime ||
                item.startTime !== this.$data.form.schedules[i - 1].startTime) {
                this.$data.form.isSameAsAbove = false; 
              }
            } 
            if(i>0 && item.id === this.$data.form.editingRowId){ 
              if(item.day === this.$data.form.schedules[i - 1].day){
                this.$data.form.isSameAsAbove = false;
              }
              if(this.$data.form.timeLeft < (this.$data.form.schedules[i - 1].endTime - this.$data.form.schedules[i - 1].startTime)){
                 this.$data.form.isSameAsAbove = false; 
              }
            }
          });
        }
      },
      close() {
        this.$emit("dialogFormVisibleEvent", false);
      },
      addRow() {
        let valid = true;
        for (let i = 0; i < this.$refs.courseScheduleTimePicker.length; i++) {
          let index = this.$refs.courseScheduleTimePicker.length - 1 - i;
          valid =
            valid && this.$refs.courseScheduleTimePicker[index].validateRow();
        }
        if (!valid) return;
        else {
          let newRow = {
            id: guid(),
            day: "",
            startTime: "",
            endTime: "",
            universityCourseType:""
          };
          this.loadUnavailbeTime();
          this.$data.form.schedules.forEach((e, i) => {
            let item = {
              id: e.id,
              dataId: 0,
              day: e.day,
              startTime: e.startTime,
              endTime: e.endTime,
              courseName:this.$data.form.courseName
            };
            this.$data.form.unavailbeTime.push(item);
          });
          this.$data.form.schedules.push(newRow);
        }
      },
      onReduceTime: function(currentRowId) {
        if (this.$data.form.schedules) {
          let timeSubtotal = 0;
          this.$data.form.schedules.forEach((item, i) => {
            if (item.endTime !== "" && item.startTime !== "") {
              let timeSpan = parseInt(item.endTime) - parseInt(item.startTime);
              timeSubtotal += timeSpan;
            }
          });
          this.$data.form.timeLeft = this.$data.form.maxTime - timeSubtotal;
          this.checkAllTimeIsSame();
        } else {
          this.$data.form.timeLeft = this.$data.form.maxTime;
        }
        this.loadUnavailbeTime();
      },
      getTimespan(startTime, endTime) {
        // let n = parseInt(endTime) - parseInt(startTime);
        // let hour = Math.floor(n / 100);
        // let mintue = Math.floor(n % 100);
        // return hour * 60 + mintue;
        let timeSpan = parseInt(endTime) - parseInt(startTime);
        return timeSpan;
      },
      onDeleteRow(currentRowId) {
        this.$data.form.schedules.forEach((item, i) => {
          if (item.id === currentRowId) {
            if (item.dataId && this.form.removeIdList.indexOf(item.dataId) < 0) {
              this.form.removeIdList.push(item.dataId);
            }
            this.$data.form.schedules.splice(i, 1);
            this.onReduceTime();
          }
        });
      },
      onEditingRow(id){ 
        this.$data.form.editingRowId = id;
         this.checkAllTimeIsSame() ;
      },
      deleteCourse() {
        this.$confirm("您确认要删除该课程吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
            deleteStudentCourse(this.courseData.id).then(result => {
              if (result.success) {
                let type = 3;
                this.$emit("save", result.data, type);
              } else {
                if (result.message) {
                  this.errorMessage = result.message;
                  this.showError = true;
                }
              }
            });
          })
          .catch(() => {});
      },
      save() {
        let isValid = true;
        this.$refs.form.validate(valid => {
          if (!valid) isValid = false;
          else {
            for (let i = 0; i < this.$refs.courseScheduleTimePicker.length; i++) {
              let index = this.$refs.courseScheduleTimePicker.length - 1 - i;
              valid =
                valid && this.$refs.courseScheduleTimePicker[index].validateRow();
            }
            if (!valid) isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }
        let studentId = getStore("user_student_id");
        if (this.$data.form.schedules.length > 0) {
          saveStudentCourse(
            studentId,
            this.courseData.id,
            this.$data.form.courseName,
            this.$data.form.schedules
          ).then(result => {
            if (result.success) {
              let type = 1;
              if (this.isEdit) {
                type = 2;
              }
              this.$emit("save", result.data, type);
            } else {
              if (result.message) {
                this.errorMessage = result.message;
                this.showError = true;
              }
            }
          });
        }
      }
    },
    watch: {
      courseData: function() {
        this.loadScheduleData();
        this.loadUnavailbeTime();
        this.checkAllTimeIsSame(); 
      }
    }
  };
</script>
<style lang="scss" scoped>
  .el-form-item {
    margin-bottom: 0px;
  }
</style>




// WEBPACK FOOTER //
// src/components/courseScheduleEditor.vue